import logFunc from 'helpers/logFunc'
import isEmpty from 'lodash/isEmpty'
import reject from 'lodash/reject'
import take from 'lodash/take'
import {addElementToStackArray} from "../addElementToStackArray";

const TOKEN_KEY = '_wTokenKey'
const Coordinates_KEY = '_wCoordinatesKey'
const EXAM_PAPER_KEY = '_wExamPaperKey'
const LANGUAGE_KEY = '_wLanguage'
const CONTENT_LANGUAGE_KEY = '_wContentLanguage'
const PRIMARY_CATEGORY_KEY =
    '_wPrimaryCategory'
const GOD_WORD_DISPLAY_CONFIG_KEY = '_wGodWordDisplayConfigKey'
const DEBUG_MODE_KEY = '_wDebugModeKey'
const SCALE_FACTOR_KEY = '_wScaleFactorKey'

export function isDebugMode() {
    return !!Number(localStorage.getItem(DEBUG_MODE_KEY));
}

export function setDebug(value) {
    localStorage.setItem(DEBUG_MODE_KEY, value)
}

export function getScaleFactor() {
    return Number(localStorage.getItem(SCALE_FACTOR_KEY)) || 0;
}

export function setScaleFactor(value) {
    localStorage.setItem(SCALE_FACTOR_KEY, Number(value))
}

export function getStoredDefaultCountryId() {
    return localStorage.getItem("default_country_id_key") || 237;
}

export function setStoredDefaultCountryId(value) {
    localStorage.setItem("default_country_id_key", value)
}

export function getCoordinatesStore() {
    const coordinates = localStorage.getItem(Coordinates_KEY);
    if (!!!coordinates) return {};
    return JSON.parse(coordinates);
}

export function setCoordinatesStore(value) {
    localStorage.setItem(Coordinates_KEY,
        JSON.stringify({
            ...value,
            timestamp: Date.now(),
        })
    )
}

export function getGodWordDisplayConfigKey() {
    return localStorage.getItem(GOD_WORD_DISPLAY_CONFIG_KEY) || "0";
}

export function setGodWordDisplayConfigKey(value) {
    localStorage.setItem(GOD_WORD_DISPLAY_CONFIG_KEY, value)
}

export function getTokenKey() {
    return localStorage.getItem(TOKEN_KEY)
}

export const setTokenKey = (token) => {
    if (!token || token === 'null' || token === 'undefined') {
        // Không ghi null vào — giữ nguyên token cũ
        return;
    }
    localStorage.setItem(TOKEN_KEY, token);
};

export function clearTokenKey() {
    localStorage.removeItem(TOKEN_KEY)
}

export const saveLanguageKey = logFunc(
    language => {
        localStorage.setItem(
            LANGUAGE_KEY,
            language
        )
    }
)
export const saveContentLanguageKey = logFunc(
    language => {
        localStorage.setItem(
            CONTENT_LANGUAGE_KEY,
            language
        )
    }
)

export function getLanguageKey() {
    return localStorage.getItem(
        LANGUAGE_KEY
    )
}

export function getContentLanguageKey() {
    return localStorage.getItem(
        CONTENT_LANGUAGE_KEY
    ) || "vi"
}

export function setPrimaryCategory(
    cate_id
) {
    localStorage.setItem(
        PRIMARY_CATEGORY_KEY,
        cate_id
    )
}

export function getPrimaryCategory() {
    return localStorage.getItem(
        PRIMARY_CATEGORY_KEY
    )
}

export function getLocalExaminationPaperKey() {
    const items = localStorage.getItem(EXAM_PAPER_KEY) || "[]";
    let jsonItems = [];
    try {
        jsonItems = JSON.parse(items);
    } catch (e) {
    }
    return jsonItems.filter(e => !isEmpty(e));
}

export function setLocalExaminationPaperKey(item) {
    const items = localStorage.getItem(EXAM_PAPER_KEY) || "[]";
    let jsonItems = [];
    try {
        jsonItems = JSON.parse(items);
    } catch (e) {
    }
    jsonItems = jsonItems.filter(e => !isEmpty(e));

    jsonItems = reject(jsonItems, function (o) {
        return o.id === item.id;
    });
    jsonItems = [item, ...jsonItems];

    localStorage.setItem(EXAM_PAPER_KEY, JSON.stringify(jsonItems.slice(0, 10)))
}

export function removeLocalExaminationPaperKey(item) {
    const items = localStorage.getItem(EXAM_PAPER_KEY) || "[]";
    let jsonItems = [];
    try {
        jsonItems = JSON.parse(items);
    } catch (e) {
    }
    jsonItems = jsonItems.filter(e => !isEmpty(e));

    jsonItems = reject(jsonItems, function (o) {
        return o.id === item.id;
    });

    localStorage.setItem(EXAM_PAPER_KEY, JSON.stringify(jsonItems))
}


export function getFavorites(key, limit = 5) {
    const favorites = localStorage.getItem("FAVORITES") || "{}";
    let jsonFavorites = [];
    try {
        jsonFavorites = JSON.parse(favorites);
    } catch (e) {
        jsonFavorites = {}
    }

    return take(jsonFavorites[key] ?? [], 5)
}

export function addFavorite(key, item, limit = 5) {
    const favorites = localStorage.getItem("FAVORITES") || "{}";
    let jsonFavorites = [];
    try {
        jsonFavorites = JSON.parse(favorites);
    } catch (e) {
        jsonFavorites = {}
    }

    const items = jsonFavorites[key] ?? [];
    jsonFavorites[key] = addElementToStackArray(items, item, limit);

    localStorage.setItem("FAVORITES", JSON.stringify(jsonFavorites))
}


// ─── Recent apps (sidebar/mobile "Truy cập nhanh" — app dùng gần nhất trong Kristo Apps) ────────
// Chỉ lưu localStorage theo máy/trình duyệt (không đụng backend) - đã chốt với user. Cùng pattern
// MRU-với-giới-hạn đang dùng cho EXAM_PAPER_KEY/FAVORITES phía trên (addElementToStackArray).
const RECENT_APPS_KEY = '_wRecentApps'
const RECENT_APPS_LIMIT = 10 // giữ dư lịch sử; phía UI (useRecentApps) chỉ lấy 3 app đầu để hiển thị

export function getRecentApps() {
    const raw = localStorage.getItem(RECENT_APPS_KEY) || "[]"
    let items = []
    try {
        items = JSON.parse(raw)
    } catch (e) {
    }
    return items.filter(e => !isEmpty(e))
}

export function addRecentApp(appId) {
    const items = getRecentApps()
    const updated = addElementToStackArray(items, {id: appId, timestamp: Date.now()}, RECENT_APPS_LIMIT)
    localStorage.setItem(RECENT_APPS_KEY, JSON.stringify(updated))
}

export const SESSION_TOKEN_KEY =
    'session_token'

export function setSessionToken(token) {
    sessionStorage.setItem(
        SESSION_TOKEN_KEY,
        token
    )
}

export function getSessionToken() {
    return sessionStorage.getItem(
        SESSION_TOKEN_KEY
    )
}

export function removeSessionToken() {
    sessionStorage.removeItem(
        SESSION_TOKEN_KEY
    )
}

const CLIENT_FINGERPRINT_KEY = '_wClientFingerprint'

const NEARBY_RADIUS_KEY = '_wNearbyRadiusKm'

export function getNearbyRadiusKm() {
    return Number(localStorage.getItem(NEARBY_RADIUS_KEY)) || 3
}

export function setNearbyRadiusKm(km) {
    localStorage.setItem(NEARBY_RADIUS_KEY, km)
}

export function getClientFingerprint() {
    let fp = sessionStorage.getItem(CLIENT_FINGERPRINT_KEY)
    if (!fp) {
        fp = (typeof crypto !== 'undefined' && crypto.randomUUID)
            ? crypto.randomUUID()
            : Math.random().toString(36).slice(2) + Date.now().toString(36)
        sessionStorage.setItem(CLIENT_FINGERPRINT_KEY, fp)
    }
    return fp
}

// ─── Device session (xem docs/api-security-design.md) ────────────────────────
// device_id: bền qua việc đóng/mở app — lưu localStorage (khác X-Client-Fingerprint ở trên là sessionStorage)
const DEVICE_ID_KEY = '_wDeviceId'
const SESSION_ID_KEY = '_wSessionId'
const SESSION_SECRET_KEY = '_wSessionSecret'

function generateUuid() {
    return (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : Math.random().toString(36).slice(2) + Date.now().toString(36)
}

export function getDeviceId() {
    let id = localStorage.getItem(DEVICE_ID_KEY)
    if (!id) {
        id = generateUuid()
        localStorage.setItem(DEVICE_ID_KEY, id)
    }
    return id
}

export function getSessionId() {
    return localStorage.getItem(SESSION_ID_KEY)
}

export function getSessionSecret() {
    return localStorage.getItem(SESSION_SECRET_KEY)
}

export function setDeviceSession(sessionId, sessionSecret) {
    if (sessionId) localStorage.setItem(SESSION_ID_KEY, sessionId)
    if (sessionSecret) localStorage.setItem(SESSION_SECRET_KEY, sessionSecret)
}

export function clearDeviceSession() {
    localStorage.removeItem(SESSION_ID_KEY)
    localStorage.removeItem(SESSION_SECRET_KEY)
}

// ─── Guest display name (Kristo Games - leaderboard cho người chơi chưa đăng nhập) ─────────
// Sinh 1 lần, giữ nguyên cho cùng trình duyệt/thiết bị - không hỏi người chơi.
const GUEST_DISPLAY_CODE_KEY = '_wGuestDisplayCode'

export function getOrCreateGuestDisplayCode(label) {
    let code = localStorage.getItem(GUEST_DISPLAY_CODE_KEY)
    if (!code) {
        code = `${label} ${Math.floor(1000 + Math.random() * 9000)}`
        localStorage.setItem(GUEST_DISPLAY_CODE_KEY, code)
    }
    return code
}